<template>
<div class="chapter">
<div class="inner_page">
<p class="Ded">To Salman, Sophie and Jasmine</p>
<p class="Ded">and the <span class="TX-Italic CharOverride-4">Exponential View</span> community</p>
<p class="CR mtop">Copyright © 2021 by Azeem Azhar </p>
<p class="CR mtop">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. </p>
<p class="CR mtop">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="CR mtop">Diversion Books </p>
<p class="CR">A division of Diversion Publishing Corp.</p>
<p class="CR"><a href="http://www.diversionbooks.com" target="_blank">www.diversionbooks.com</a></p>
<p class="CR mtop">First Diversion Books edition, September 2021</p>
<p class="CR">Hardcover ISBN: 978-1-63576-909-8</p>
<p class="CR">eBook ISBN: 978-1-63576-908-1</p>
<p class="CR mtop">Printed in the United States of America</p>
<p class="CR">1 3 5 7 9 10 8 6 4 2</p>
<p class="CR _idGenParaOverride-1">Library of Congress cataloging-in-publication data is available on file.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f003.vue?1687daa8